import { Clientes } from '@/interface/cliente.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingService } from '@services/loading.service';

@Component({
  selector: 'app-lista-clientes',
  templateUrl: './lista-clientes.component.html',
  styleUrls: ['./lista-clientes.component.scss']
})
export class ListaClientesComponent implements OnInit {
  @Input() clientes: Clientes;
  @Output() updateData = new EventEmitter();

  constructor(private router: Router,
    private fb: FormBuilder,
    private loadingService: LoadingService
  ) {
  }

  ngOnInit(): void {  
  }

  updData() {
    this.updateData.emit()
  }

  goDetalleCliente(idCliente){    
    this.loadingService.setLoading(true);
    localStorage.setItem('idCliente', idCliente);
    this.router.navigate(['/cliente']);
  }


}
